export default __webpack_public_path__ + "static/media/logo.84b8d316.svg";